// extracted by mini-css-extract-plugin
module.exports = {"modal":"SubscribeFormModel_modal__1YcQ2"};